module.exports = __webpack_public_path__ + "static/img/head-es.03fc0427.webp";